// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BaseModal-module__modalOverlay--sYX2T {
  z-index: 100;
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
}
.BaseModal-module__modalOverlay--sYX2T.BaseModal-module__absoluteOverlay--M50H0 {
  position: absolute;
}

.BaseModal-module__modalBox--JCPBN {
  display: block;
  background: white;
  width: 31.25rem;
  min-height: 12.5rem;
  max-height: 80vh;
  padding: 1.5rem;
  border-radius: 0.5rem;
  overflow-y: auto;
}
@media (max-width: 1024px) {
  .BaseModal-module__modalBox--JCPBN {
    width: fit-content;
  }
}

.BaseModal-module__pinToTop--uBZWB {
  border-radius: 0 0 0.5rem 0.5rem;
  position: absolute;
  top: 0;
}

/** The following styles are used for the ProjectLoadingOverlay, which is an overlay that uses the modal system */
.BaseModal-module__softOverlay--GCWVT {
  background: rgba(0, 0, 0, 0.3);
}

.BaseModal-module__noModal--rp51c {
  visibility: hidden;
}`, "",{"version":3,"sources":["webpack://./src/components/Modals/BaseModal.module.scss"],"names":[],"mappings":"AAAA;EACC,YAAA;EACA,WAAA;EACA,aAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,8BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AACD;AACC;EACC,kBAAA;AACF;;AAGA;EACC,cAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,qBAAA;EACA,gBAAA;AAAD;AACC;EATD;IAUE,kBAAA;EAEA;AACF;;AACA;EACC,gCAAA;EACA,kBAAA;EACA,MAAA;AAED;;AACA,iHAAA;AACA;EACC,8BAAA;AAED;;AAAA;EACC,kBAAA;AAGD","sourcesContent":[".modalOverlay {\n\tz-index: 100; // Make sure it's on top of everything\n\twidth: 100%;\n\theight: 100vh;\n\tposition: fixed;\n\ttop: 0;\n\tleft: 0;\n\tbackground: rgba(0, 0, 0, 0.7);\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\n\t&.absoluteOverlay {\n\t\tposition: absolute;\n\t}\n}\n\n.modalBox {\n\tdisplay: block;\n\tbackground: white;\n\twidth: 31.25rem;\n\tmin-height: 12.5rem;\n\tmax-height: 80vh;\n\tpadding: 1.5rem;\n\tborder-radius: 0.5rem;\n\toverflow-y: auto;\n\t@media (max-width: 1024px) {\n\t\twidth: fit-content;\n\t}\n}\n\n.pinToTop {\n\tborder-radius: 0 0 0.5rem 0.5rem;\n\tposition: absolute;\n\ttop: 0;\n}\n\n/** The following styles are used for the ProjectLoadingOverlay, which is an overlay that uses the modal system */\n.softOverlay {\n\tbackground: rgba(0, 0, 0, 0.3);\n}\n.noModal {\n\tvisibility: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalOverlay": `BaseModal-module__modalOverlay--sYX2T`,
	"absoluteOverlay": `BaseModal-module__absoluteOverlay--M50H0`,
	"modalBox": `BaseModal-module__modalBox--JCPBN`,
	"pinToTop": `BaseModal-module__pinToTop--uBZWB`,
	"softOverlay": `BaseModal-module__softOverlay--GCWVT`,
	"noModal": `BaseModal-module__noModal--rp51c`
};
export default ___CSS_LOADER_EXPORT___;
